import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="h-full w-full flex items-center justify-center p-6">
      <div className="text-center space-y-3">
        <h1 className="text-display fluid-2xl text-ash-200">El camino se bifurca en vacío</h1>
        <p className="text-narrative italic text-ash-500 fluid-base">No existe esa ruta.</p>
        <Link
          to="/menu"
          className="inline-block text-moss-300 underline underline-offset-4 font-ui fluid-xs uppercase tracking-widest"
        >
          Volver al menú
        </Link>
      </div>
    </div>
  );
}
